export default [
  {
    path: '/unauthorized',
    name: 'unauthorized',
    component: () => import('@/views/unauthorized'),
    meta: {
      openPanel: false,
    },
  },
  {
    path: '/**',
    name: 'error-404',
    component: () => import('@/views/404'),
  },
];
